import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {UserThemeConsumer} from '../../../../libs/shared/ui/src/theme/userThemeConsumer';
import {ArbitraryCalendarEventParticipantModel} from '../../../models/api/visualParticipantModel';
import {Avatar} from '../../common/avatars/avatar';
import {AvatarBackground} from '../../common/avatars/avatarBackground';
import {AvatarInitials} from '../../common/avatars/avatarInitials';
import {maybeRenderBadge} from '../../common/avatars/contactAvatarWithResponseStatus';
import {
  maybeRenderParticipantDescriptor,
  StyledParticipantDescriptorSpan,
  StyledParticipantTextDiv,
} from './calendarEventParticipantsItem';

/*
 * Props.
 */

interface ArbitraryCalendarEventParticipantsItemProps {
  participant: ArbitraryCalendarEventParticipantModel;
}

/*
 * Style.
 */

const StyledParticipantDiv = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 20px auto;
  grid-column-gap: 12px;
  padding: 5px 8px;
  border-radius: 4px;

  background-color: ${(p) => p.theme.foreground};
  overflow: hidden;
`;

/*
 * Component.
 */

export const ArbitraryCalendarEventParticipantsItem: FC<ArbitraryCalendarEventParticipantsItemProps> = (
  props,
) => (
  <UserThemeConsumer>
    {(theme) => {
      const {participant} = props;
      return (
        <StyledParticipantDiv>
          <Avatar size={VisualSizesEnum.MEDIUM}>
            <AvatarBackground color={theme.greys.shade70} />
            <AvatarInitials
              size={VisualSizesEnum.MEDIUM}
              value={participant.address.length > 0 ? participant.address.substring(0, 1) : ''}
              textColor={theme.invertedText}
            />
            {maybeRenderBadge(participant.responseStatus, false)}
          </Avatar>
          <StyledParticipantTextDiv>
            {renderParticipantName(participant)}{' '}
            <StyledParticipantDescriptorSpan>
              {maybeRenderParticipantDescriptor(participant)}
            </StyledParticipantDescriptorSpan>
          </StyledParticipantTextDiv>
        </StyledParticipantDiv>
      );
    }}
  </UserThemeConsumer>
);

function renderParticipantName(participant: ArbitraryCalendarEventParticipantModel) {
  return participant.address;
}
